<template>
    <v-layout row wrap class="px-4 py-2">
        <!-- Pricing plan title -->

        <v-flex xs12 class="pb-1">
            <span class="primary--text text--darken-1">
                <b>{{ _label() }}</b> <!-- Event/Pricing Plan/Seats -->
            </span>
            <div>
                <div class="headline secondary--text">{{ _paidItemName() }}</div>
                <!-- Event date time in case of venue event -->
                <div v-if="event_type == DEFINES.SCREENER_TYPE_VALUE.PHYSICAL" class="subheading">{{ moment.utc(screener.screening_starts_at).local().format("lll") }}</div>
            </div>
        </v-flex>
        <!-- Seats -->
        <v-flex v-if="event_type == DEFINES.SCREENER_TYPE_VALUE.PHYSICAL" xs12 class="pb-1">
            <span class="primary--text text--darken-1">

                <b>{{$t('screener.seats.cart.total_seats.title')}}</b>
            </span>
            <div >
                <span class="headline secondary--text">{{ this.seats.length }}</span>
                <span class="subheading px-1 secondary--text">({{_joinSeatLabels()}})</span>
            </div>
        </v-flex>

        <!-- Vod type event availabilty -->
        <v-flex v-if="screener && screener.is_vod_event" xs12 pb-1>
            <span class="secondary--text text--lighten-2">
                <b>{{$t('vod.first.time.availability.msg', {hours: screener.vod_availability})}}</b>
            </span>
        </v-flex>

        <!-- Payable amount with discount if any -->
        <v-flex xs12>
            <span class="primary--text text--darken-1">
                <b>{{ $t("enrollment.steps.payment.component.total_to_pay") }}</b>
            </span>
            <div class="headline secondary--text">
                {{ getCurrencySymbol(currency) }}{{ price | fixed }}
                <span v-if="applied_coupon.applicable" class="title ml-2 success--text">({{ applied_coupon.discount_percentage }}% Off)</span>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
import { currencySymbol } from "@/mixins/currencySymbol";

export default {
    name:"PaymentCheckoutSummary",
    props:{
        pricing:{
            type:Object,
            default:null
        },
        screener:{
            type:Object,
            default:null
        },
        seats:{
            type:Array,
            default:function(){
                return [];
            }
        },
        event_type:{
            default: function(){
                return this.DEFINES.SCREENER_TYPE_VALUE.VIRTUAL;
            }
        },
        price:{
            type:Number|String,
            default:null
        },
        currency:{
            type:String,
            default:null
        },
        applied_coupon:{
            type:Object,
            default:null
        }
    },
    mixins:[currencySymbol],
    methods:{
        _label(){
            if(this.pricing){
                switch (this.pricing.type) {
                    case this.DEFINES.MONETIZATION.PRICING_TYPE.SINGLE_PURCHASE:
                        return this.$t("screening.register.lable.screening");
                    case this.DEFINES.MONETIZATION.PRICING_TYPE.GROUP_PURCHASE:
                        return this.$t("screener.pricing_plan.title")
                    case this.DEFINES.MONETIZATION.PRICING_TYPE.SUBSCRIPTION:
                        return this.$t("screener.pricing_plan.title");
                    default:
                       return this.$t("screening.register.lable.screening");
                }
            }
            if(this.screener)
            {
                return this.$t("screening.register.lable.screening");
            }
        },
        _joinSeatLabels(glue = ", "){
            if(!this.seats.length){
                return;
            }
            return this.seats.map(seat => seat.label).join(glue);
        },
        _paidItemName(){
            if(this.pricing){
                return this.pricing.name;
            }
            if(this.screener)
            {
                return this.screener.title;
            }
        },
    }
}
</script>

<style>

</style>
